<template>
  <div class="single-apply-area">
    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        v-loading="loading"
    >
      <div class="upload-image">
        <div class="fz14 top-text">
          <div class="mb5" style="width: 100px">
            <span style="color: red" class="mr5">*</span>上传材料：
          </div>
          <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
        </div>
        <el-form-item label-width="0px" prop="idCardFrontId">
          <el-input style="display: none" v-model="ruleForm.idCardFrontId"></el-input>
          <el-upload
              class="avatar-uploader"
              multiple
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 0)"
              :on-change="onChangeFront"
              action="/"
              accept="image/*"
          >
            <img class="image-card" v-if="imageUrlFront" :src="imageUrlFront" alt/>
            <img
                class="icon-check"
                v-if="imageUrlFront"
                @click.stop="checkImage('front')"
                src="@/assets/login/icon-check-img.png"
                alt
            />
            <img v-if="!imageUrlFront" src="@/assets/login/image-card-people.png" alt/>
            <span v-if="!imageUrlFront" class="fz14 fc9">上传身份证人像面照片</span>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="0px" prop="idCardReserveId">
          <el-input style="display: none" v-model="ruleForm.idCardReserveId"></el-input>
          <el-upload
              class="avatar-uploader"
              multiple
              :show-file-list="false"
              :before-upload="(e) => handleBeforeUpload(e, 1)"
              :on-change="onChangeReserve"
              action="/"
              accept="image/*"
          >
            <img class="image-card" v-if="imageUrlReserve" :src="imageUrlReserve" alt/>
            <img
                class="icon-check"
                v-if="imageUrlReserve"
                @click.stop="checkImage('reserve')"
                src="@/assets/login/icon-check-img.png"
                alt
            />
            <img v-if="!imageUrlReserve" src="@/assets/login/image-card-emblem.png" alt/>
            <span v-if="!imageUrlReserve" class="fz14 fc9">上传身份证国徽面照片</span>
          </el-upload>
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" label="用户姓名">
            <el-input v-model="ruleForm.name" placeholder="请输入用户姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="idCard" label="身份证号">
            <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="telephone" label="手机号码">
            <el-input
                type="number"
                v-model="ruleForm.telephone"
                :maxlength="11"
                placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item style="position: relative" prop="password" label="登录密码">
            <el-input
                show-password
                v-model="ruleForm.password"
                placeholder="请输入登录密码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item class="captcha-item" prop="smsCode" label="验证码">
            <el-input
                v-model="ruleForm.smsCode"
                placeholder="请输入短信验证码"
            ></el-input>
            <div v-if="!hadSend" class="get-cap" @click="getCaptcha">获取验证码</div>
            <div v-if="hadSend" class="get-cap">{{ count }}s重新获取</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="email" label="邮箱">
            <el-input
                type="text"
                v-model="ruleForm.email"
                placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item prop="inviteCode" label="邀请码">
            <el-input v-model="ruleForm.inviteCode" placeholder="请输入邀请码"></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-form-item>
        <el-button class="next-button" type="primary" @click="submitForm('ruleForm')"
        >确认无误，下一步
        </el-button
        >
      </el-form-item>
    </el-form>
    <el-image-viewer v-if="isShowPics" :on-close="closeViewer" :url-list="srcList"/>
    <verify-code ref="verifyRef" @getMessage="getMessage"></verify-code>
    <check-example ref="checkRef"></check-example>
    <face-check ref="faceRef" @subPersonSeal="subPersonSeal"></face-check>
  </div>
</template>
<script>
import verifyCode from "@/components/VerifyCode.vue";
import CheckExample from "./CheckExample.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import FaceCheck from "./FaceCheck.vue";

export default {
  components: {verifyCode, CheckExample, ElImageViewer, FaceCheck},
  data() {
    const validPass = (rule, value, callback) => {
      let reg = /(?!^(\d+|[A-Z]+|[a-z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入设置您的登录密码"));
      } else if (!reg.test(value)) {
        callback(
            new Error(
                "密码长度为8-16位;必须包含大写字母、小写字母、数字和特殊字符中的两种或以上"
            )
        );
      } else {
        callback();
      }
    };

    const validIdCard = (rule, value, callback) => {
      let reg = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/;
      if (value === "") {
        callback(new Error("请输入用户身份证号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入合法的身份证号"));
      } else {
        callback();
      }
    };

    const validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };

    const validateEmail = (rule, value, callback) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value === "") {
        callback(new Error("请输入电子邮箱"));
      } else if (!emailRegex.test(value)) {
        callback(new Error("请输入正确的电子邮箱"));
      } else {
        callback();
      }
    }

    return {
      imageUrlFront: "",
      imageUrlReserve: "",
      isShowPics: false,
      srcList: [],
      hadSend: false,
      count: 60,
      timer: null,
      loading: false,
      ruleForm: {
        name: undefined,
        idCard: undefined,
        telephone: undefined,
        password: undefined,
        smsCode: undefined,
        email: undefined,
        // inviteCode: undefined,
      },
      rules: {
        name: [{required: true, message: "请输入用户姓名", trigger: "blur"}],
        idCard: [{required: true, validator: validIdCard, trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}],
        password: [{required: true, validator: validPass, trigger: "blur"}],
        smsCode: [{required: true, message: "请输入短信验证码", trigger: "blur"}],
        idCardFrontId: [{
          required: true,
          message: "请上传身份证人像面照片",
          trigger: "change",
        }],
        idCardReserveId: [{
          required: true,
          message: "请上传身份证国徽面照片",
          trigger: "change",
        }],
        email: [
          {required: true, validator: validateEmail, trigger: "blur"},
        ],
      },
      raw: null,
    };
  },
  methods: {
    checkExampleDia() {
      this.$refs.checkRef.show("single");
    },
    request(base, type) {
      let params = {
        type: type + '',
        imageBase64: base,
      };
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 0) {
            this.$set(this.ruleForm, "idCardFrontId", res.data.data.imageId);
          } else if (type == 1) {
            this.$set(this.ruleForm, "idCardReserveId", res.data.data.imageId);
          }

          if (res.data.data.name) {
            this.$set(this.ruleForm, "name", res.data.data.name);
          }

          if (res.data.data.idCard) {
            this.$set(this.ruleForm, "idCard", res.data.data.idCard);
          }

          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }

        this.loading = false;
      });
    },
    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        if (type == 0) {
          this.imageUrlFront = e.target.result;
        } else if (type == 1) {
          this.imageUrlReserve = e.target.result;
        }

        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };

      return false; // 阻止默认上传行为
    },
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onChangeReserve(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    handlePictureCardPreview() {
    },
    getCaptcha() {
      if (!this.ruleForm.telephone) {
        this.$message.warning("请先输入手机号码");
        return;
      }
      this.$refs.verifyRef.show();
    },
    getMessage(param) {
      let params = param;
      params.telephone = this.ruleForm.telephone;
      params.type = 'register';
      this.loading = true;
      this.$http.post(this.$api.register.sendSMSCode, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.hadSend = true;
          this.count = 60;
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
            } else {
              if (this.timer) {
                this.hadSend = false;
                clearInterval(this.timer);
              }
            }
          }, 1000);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.$refs.faceRef.show(this.ruleForm, "用户");

          // let phoneParams = {
          //   phone: this.ruleForm.telephone,
          //   smsCode: this.ruleForm.smsCode,
          // };
          // this.loading = true;
          // this.$http.post(this.$api.register.verifySMSCode, phoneParams).then((res) => {
          //   this.loading = false;
          //   if (res.data.code == 200) {
          //   } else {
          //     this.$message.error(res.data.msg);
          //   }
          // });
        }
      });
    },
    subPersonSeal(checkId) {
      let params = {
        ...this.ruleForm,
        checkId: checkId,
      };
      this.loading = true;
      this.$http.post(this.$api.register.submitPersonalSeal, params).then((res) => {
        this.loading = false;
        if (res.data.code == 200) {
          this.$auth.setUserId(res.data.data.userId);
          this.$router.push({
            path: "/register/sealConfirm",
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    checkImage(flag) {
      this.srcList = [];
      if (flag == "front") {
        this.srcList.push(this.imageUrlFront);
      } else {
        this.srcList.push(this.imageUrlReserve);
      }
      this.isShowPics = true;
    },
    closeViewer() {
      this.isShowPics = false;
    },
  },
};
</script>
<style lang="less" scoped>
.single-apply-area {
  margin-left: 112px;
  margin-right: 112px;

  .upload-image {
    display: flex;
    align-items: flex-start;
    margin-bottom: 22px;

    .top-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
    }
  }

  .captcha-item {
    position: relative;
  }

  .get-cap {
    position: absolute;
    right: 20px;
    top: 0px;
    color: #407fff;
    cursor: pointer;
  }

  .next-button {
    width: 350px;
    font-size: 16px;
    padding: 11px 20px !important;
    margin-top: 40px;
    box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
  }
}

.avatar-uploader {
  position: relative;
  width: 264px;
  height: 180px;
  margin-right: 40px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}

::v-deep .el-form-item {
  margin-bottom: 28px !important;
}

::v-deep .el-form-item__error {
  text-align: left !important;
}
</style>
